import React, { forwardRef, useMemo } from "react";
import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import PageRecord from "models/view-models/page-record";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import DeprecatedShow from "atoms/wrappers/show";

export interface RelocatePageMenuItemProps extends ButtonProps {
    page: PageRecord;
    onClick: () => void;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const RelocatePageMenuItem = forwardRef<
    HTMLButtonElement,
    RelocatePageMenuItemProps
>((props, ref) => {
    const { page, onClick } = props;
    const { t } = useLocalization();
    const { can } = usePageActionPermission(page);
    const canRelocate = useMemo(() => can(PageAction.Relocate), [can]);

    return (
        <DeprecatedShow when={canRelocate}>
            <Button
                accessibleText={t("moveItem", {
                    item: t("page"),
                })}
                cssClassName={`${CSS_CLASS_NAME}__button`}
                onClick={onClick}>
                <Icon type={Icons.Notebook} />
                {t("moveItem", {
                    item: t("page"),
                })}
            </Button>
        </DeprecatedShow>
    );
});

export default RelocatePageMenuItem;
